export default "__VITE_ASSET__D9UTHOOx__"